import { axios } from '@src/plugins/axios-pol'

export default class ArmeriaApiRepository {
  async findAll() {
    const { data } = await axios.get('/armeria/api/Armeria/auditoria')
    return data.data
  }

  async create(payload) {
    const { data } = await axios.post('/armeria/api/Armeria/auditoria', payload)
    return data.data
  }

  async findById(idAuditoria) {
    const { data } = await axios.get(`/armeria/api/Armeria/auditoria/${idAuditoria}`)
    return data.data
  }

  async getPersonalArmas() {
    const { data } = await axios.get('/armeria/api/Armeria/personal/armas')
    return JSON.parse(data.data)
  }

  async removePersonalLoc(idPersonal, idPersonalLoc) {
    await axios.put(`/armeria/api/Armeria/personal/${idPersonal}/personalLoc/${idPersonalLoc}/remueveLOC`)
  }
}
